import { ref } from 'vue'
const apiCollection = require('@/data/api_collection_v3.json')
const routes = ref([])
const dataCollection = ref([])
const dataDocumentation = ref([])

dataCollection.value = apiCollection.item
dataCollection.value.forEach(item => {
  if (item.item) {
    const documentation = {
      index: item.name,
      name: item.name,
      sub_menu: []
    }
    item.item.forEach(child => {
      documentation.sub_menu.push({
        index: child.name,
        sub_name: child.name,
        url: '/documentation/' + child.name.replace(/\s+/g, '-').toLowerCase()
      })
    })
    dataDocumentation.value.push(documentation)
  }
})

routes.value.push({
  path: 'introduction',
  name: 'Introduction',
  component: () => import('@/views/guarded/documentation/introduction/Index.vue')
})

routes.value.push({
  path: 'developer-guide',
  name: 'Developer Guide',
  component: () => import('@/views/guarded/documentation/developer_guide/Index.vue')
})

routes.value.push({
  path: 'api-call-flow',
  name: 'Api Call Flow',
  component: () => import('@/views/guarded/documentation/api_call_flow/Index.vue')
})

routes.value.push({
  path: 'webhook/open-order-update-status',
  name: 'Open Order Update Status',
  component: () => import('@/views/guarded/documentation/webhook/OpenOrder.vue')
})

routes.value.push({
  path: 'webhook/sales-return-update-status',
  name: 'Sales Return Update Status',
  component: () => import('@/views/guarded/documentation/webhook/SalesReturn.vue')
})

routes.value.push({
  path: 'webhook/open-purchase-update-status',
  name: 'Open Purchase Update Status',
  component: () => import('@/views/guarded/documentation/webhook/OpenPurchase.vue')
})

routes.value.push({
  path: 'webhook/purchase-return-update-status',
  name: 'Purchase Return Update Status',
  component: () => import('@/views/guarded/documentation/webhook/PurchaseReturn.vue')
})

dataCollection.value.forEach(item => {
  if (item.item) {
    item.item.forEach(child => {
      const pathRoute = child.name.replace(/\s+/g, '-').toLowerCase()
      routes.value.push({
        path: pathRoute,
        name: child.name,
        component: () => import('@/views/guarded/documentation/collection/Index.vue')
      })
    })
  }
})

export {
  routes,
  dataCollection,
  dataDocumentation
}
